export default function importStudentsSelectors(state) {
    return {
        ...state.importStudents
    }
}


// WEBPACK FOOTER //
// ./src/selectors/importStudentSelector.js